export const seoContentPaths = [
  "/help/",
  "/resources/",
  "/locations/",
  "/how-it-works/",
  "/vrbo-grocery-delivery/",
  "/vacation-home-grocery-delivery/",
  "/airbnb-grocery-delivery-before-check-in/",
  "/luxury-vacation-rental-grocery-stocking/",
  "/vacation-rental-grocery-delivery-for-families/",
  "/vacation-rental-grocery-delivery-for-groups/",
  "/vacation-rental-arrival-services/",
  "/bellhopt-vs-instacart-for-airbnb/",
  "/vacation-rental-grocery-program/",
  "/vacation-rental-concierge-app/",
  "/for/airbnb-hosts/",
  "/for/enterprise-property-managers/",
  "/for/luxury-vacation-rental-managers/",
  "/help/airbnb-grocery-delivery-how-it-works/",
  "/help/delivery-vs-stocking/",
  "/help/what-is-grocery-stocking/",
  "/help/24-hour-lead-time-policy/",
  "/help/airbnb-kitchen-stocking-vs-concierge-stocking/",
  "/resources/booking-confirmation-email-template-pre-arrival-groceries/",
  "/resources/pm-launch-kit-guest-grocery-program/",
  "/resources/stocking-list-2-night-stay/",
  "/resources/stocking-list-4-night-stay/",
  "/resources/stocking-list-7-night-stay/",
  "/resources/reduce-guest-complaints-pre-arrival-groceries/"
];

